import store from "@fawter/components/Invoices/InvoiceStore";

const responseStore = {
  response: null
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetch(to.params.hash);
  next();
};

export default {
  title () {
    return `Invoice - ${Dashboard.currentTenant.name}`;
  },

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      store: store
    };
  },

  computed: {
    invoice: {
      cache: false,
      get () {
        return this.responseStore.response.resource;
      },
      set (value) {
        this.responseStore.response.resource = value;
      }
    },

    invoiceStatus: {
      cache: false,
      get () {
        return this.invoice.status;
      }
    },

    company () {
      return this.invoice.merchant_info;
    },

    paidInvoice () {
      return this.invoiceStatus === "paid";
    },

    outstandingInvoice () {
      return this.invoiceStatus === "outstanding";
    },

    overdueInvoice () {
      return this.invoiceStatus === "overdue";
    },

    draftInvoice () {
      return this.invoiceStatus === "draft";
    },

    payableInvoice () {
      return this.outstandingInvoice || this.overdueInvoice;
    },

    showPaymentMethods () {
      return this.paymentMethods.length > 0;
    },

    paymentMethods () {
      return this.$_.orderBy(this.invoice.payment_methods, "visual_order_number");
    },

    pillColorClass () {
      if (this.invoiceStatus === "paid") {
        return "status-green";
      } else if (this.invoiceStatus === "outstanding") {
        return "status-blue";
      } else if (this.invoiceStatus === "void") {
        return "status-yellow";
      } else if (this.invoiceStatus === "draft") {
        return "status-grey";
      } else {
        return "status-red";
      }
    }
  },

  mounted () {
    if (this.resource.subject) {
      this.addBreadcrumb(`${this.resource.merchant_invoice_number} - ${this.resource.subject}`);
    } else {
      this.addBreadcrumb(`${this.resource.merchant_invoice_number}`);
    }

    if (this.paymentMethods.length) {
      this.selectedPaymentMethod = this.paymentMethods[0];
    }
    if (responseStore.response.errorMessages) {
      this.notifyErrors([responseStore.response.errorMessages]);
    }
  },

  methods: {
    setSelectedPaymentMethod (paymentMethod) {
      this.selectedPaymentMethod = paymentMethod;
    }
  }
}
